import { TriggeredMessageListItemFragment, TriggeredMessagesListQuery } from '@occc/graphql';

export const mapEdgesToTriggeredMessagesArray = (
  edges: TriggeredMessagesListQuery['triggeredMessagesList']['edges'],
): TriggeredMessageListItemFragment[] => {
  return edges.map((edge) => edge.node);
};
